import AmioHttpService from './amio-http.service'

class EventService extends AmioHttpService {

  create(botId, type, name, description, conversationJson, templateRefs, variableRefs, answerRefs) {
    return this.requestPost(`/bots/${botId}/events`, {
      type, name, description,
      conversation_json: conversationJson,
      template_refs: templateRefs,
      variable_refs: variableRefs,
      answer_refs: answerRefs
    })
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  get(botId, eventId) {
    return this.requestGet(`/bots/${botId}/events/${eventId}`)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getReferencedConversations(botId, eventId) {
    return this.requestGet(`/bots/${botId}/events/${eventId}/referenced-conversations`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  list(botId) {
    return this.requestGet(`/bots/${botId}/events`)
      .then(response => response.data)
      .then(events => events.map(adapt))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  update(botId, eventId, patch) {
    return this.requestPatch(`/bots/${botId}/events/${eventId}`, patch)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  delete(botId, eventId) {
    return this.requestDelete(`/bots/${botId}/events/${eventId}`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

function adapt(event) {
  const adaptedEvent = {
    id: event.id,
    name: event.name,
    description: event.description,
    type: event.type
  }

  if (event.conversation_json) {
    adaptedEvent.conversationJson = event.conversation_json
    adaptedEvent.conversationJsonHash = event.conversation_json_hash
  }

  return adaptedEvent
}

export default new EventService()
